/**
 * "Save as PDF" for Know your data: the browser's own print dialog, with the
 * page's print styles (KnowYourData.tsx `print:` classes) hiding everything
 * that only works on screen.
 *
 * The browser draws the PDF itself, so Arabic, right-to-left and the bars come
 * out exactly as on screen; the dashboard's jsPDF route has to rasterise
 * Arabic to get there (components/dashboard/exportPdf.ts).
 *
 * Two things are set for the length of the print and put back after:
 *  - document.title, which the browser offers as the PDF's file name;
 *  - the light theme, so a dark-mode reader does not print a black page.
 */
export function savePageAsPdf(fileTitle: string): void {
  const root = document.documentElement;
  const title = document.title;
  const wasDark = root.classList.contains('dark');
  let restored = false;

  const restore = () => {
    if (restored) return;
    restored = true;
    document.title = title;
    if (wasDark) {
      root.classList.remove('light');
      root.classList.add('dark');
    }
    window.removeEventListener('afterprint', restore);
  };

  document.title = fileTitle;
  if (wasDark) {
    root.classList.remove('dark');
    root.classList.add('light');
  }
  window.addEventListener('afterprint', restore);
  try {
    // Blocks until the dialog closes on desktop Chrome and Edge; returns at
    // once on some mobile browsers, where afterprint does the restoring.
    window.print();
  } catch {
    restore();
  }
}

/** "Know your data - 2026-10-21": a file name that sorts by date. */
export function pdfTitle(day = new Date()): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `Know your data - ${day.getFullYear()}-${p(day.getMonth() + 1)}-${p(day.getDate())}`;
}
